
    import { computed, defineComponent } from 'vue';
    import Moment from 'moment'
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification'
    import { Push } from '@progress/kendo-vue-animation'
    import { useNotificationStore } from '@/store/notification'
    import { useUserStore } from '@/store/user'
    import { useLocalizationStore } from '@/store/localization'
    import { LocalizationProvider } from '@progress/kendo-vue-intl'
    import { useLocalizedPagerTitles } from '@/util/functions/useLocalizedPagerTitles'

    export default defineComponent({
        name: 'App',

        components: {
            Push,
            Notification,
            NotificationGroup,
            LocalizationProvider
        },

        setup() {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/
            // Set current locale for date/time formatting
            Moment.locale(navigator.language)

            useLocalizedPagerTitles()

            const notificationStore = useNotificationStore()
            const userStore = useUserStore()
            const localizationStore = useLocalizationStore()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = { }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const notifications = computed(() => notificationStore.activeNotifications)
            const debugNotifications = computed(() => notificationStore.debugNotifications)

            const kendoLocale = computed(() => {
                switch (userStore.language) {
                    case 'K': return 'da-DK'
                    case 'D': return 'de'
                    case 'V': return 'sv'
                    default:  return 'en'
                }
            })

            const localizationReady = computed(() => localizationStore.hasLoaded)

            const computedData = { notifications, debugNotifications, kendoLocale, localizationReady }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            function onNotificationClose(id: any) {
                notificationStore.removeNotification(id)
            }

            function onNotificationAction(notification: any) {
                notification.action?.()
                notificationStore.removeNotification(notification.id)
            }

            const publicMethods = { onNotificationClose, onNotificationAction }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods };
        }
    })
